import { z } from "zod";
// Response shape for GET /tags. The endpoint returns the user's full tag set
// as a flat list (not cursor-paginated) — tags are a small per-user set and
// the contacts-list tag filter needs them all at once to populate its picker.
// Mirrors the geo reference-data envelope ({ items }).
/** A single tag: its id plus name. */
export const tagItemSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const tagsResponseSchema = z.object({
    items: z.array(tagItemSchema),
});
//# sourceMappingURL=tag.js.map